import { useEffect, useRef, useState } from "react";

const useChartDimensions = (initial = { w: 600, h: 300 }) => {
  const ref = useRef(null);
  const [dims, setDims] = useState(initial);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const r = entry.contentRect;
        setDims({ w: Math.max(1, Math.floor(r.width)), h: Math.max(1, Math.floor(r.height)) });
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return { ref, dims };
};

export default useChartDimensions;

